import { useEffect, useRef, useState } from 'react'

export type ScrollDirection = 'up' | 'down'

const useScrollDirection = (threshold: number) => {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>('up')
  const lastScrollY = useRef(typeof window !== 'undefined' ? window.scrollY : 0)
  const scrollDirectionRef = useRef<ScrollDirection>('up')

  useEffect(() => {
    scrollDirectionRef.current = scrollDirection
  }, [scrollDirection])

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleScroll = () => {
      const currentScrollY = window.scrollY
      if (currentScrollY < threshold) {
        if (scrollDirectionRef.current !== 'up') {
          setScrollDirection('up')
        }
      } else if (currentScrollY > lastScrollY.current && scrollDirectionRef.current !== 'down') {
        setScrollDirection('down')
      } else if (currentScrollY < lastScrollY.current && scrollDirectionRef.current !== 'up') {
        setScrollDirection('up')
      }
      lastScrollY.current = currentScrollY
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [threshold])

  return scrollDirection
}

export default useScrollDirection
